<template>
    <div class="page">
        <div class="page-header">
            <el-button @click="$router.go(-1)" type="default" size="medium">返回</el-button>
            <el-select style="margin-left: 10px;" v-model="status" placeholder="请选择" @change="changeHandler">
                <el-option label="全部" :value="0"></el-option>
                <el-option label="未处理" :value="1"></el-option>
                <el-option label="已处理" :value="2"></el-option>
                <el-option label="已通知" :value="3"></el-option>
            </el-select>
            <el-date-picker
                v-model="dateRange"
                :clearable="false"
                type="daterange"
                range-separator="至"
                @change="dateRangeChange"
                start-placeholder="开始日期"
                end-placeholder="结束日期">
            </el-date-picker>
            <a class="export-btn" :href="exportURL" download="导出" target="_blank">
                <el-button class="filter-item" type="primary" size="medium">导出</el-button>
            </a>
        </div>
        <div class="page-main" :style="{height: `${containerHeight}px`}">
            <el-table
                :data="dataList"
                style="width: 100%"
                height="80%"
            >
                <el-table-column
                    type="index"
                    width="50">
                </el-table-column>
                <el-table-column
                    prop="content"
                    label="留言内容"
                    width="170"
                >
                    <template slot-scope="scope">
                        <div class="content-container">
                            <router-link :to="{path: 'messageDetail', query: {messageId: scope.row.id}}">
                                {{scope.row.content}}
                            </router-link>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column
                    label="来源"
                    width="170">
                    <template slot-scope="scope">
                        {{scope.row.source | parseSource}}
                    </template>
                </el-table-column>
                <el-table-column
                    prop="createUserName"
                    label="提交人"
                    width="130">
                </el-table-column>
                <el-table-column
                    prop="createTime"
                    label="提交时间"
                    width="170">
                    <template slot-scope="scope">
                        {{scope.row.createTime | timeSuffixFilter}}
                    </template>
                </el-table-column>
                <el-table-column
                    prop="batchTime"
                    label="处理时间"
                    width="170">
                    <template slot-scope="scope">
                        <span v-if="scope.row.batchTime">
                            {{scope.row.batchTime | timeSuffixFilter}}
                        </span>
                        <span v-else>--</span>
                    </template>
                </el-table-column>
                <el-table-column
                    label="响应间隔"
                >
                    <template slot-scope="scope">
                        {{calcInterval(scope.row.createTime, scope.row.batchTime)}}
                    </template>
                </el-table-column>

                <el-table-column
                    label="状态">
                    <template slot-scope="scope">
                        <span v-if="scope.row.source === 1">
                            {{scope.row.status | parseStatus}}
                        </span>
                        <span v-else>
                            {{scope.row.status | parseStatus2}}
                        </span>
                    </template>
                </el-table-column>
                <el-table-column
                    label="操作"
                    width="170">
                    <template slot-scope="scope">
                        <el-button
                            :disabled="scope.row.status !== 1"
                            size="small"
                            type="text"
                            @click="batchClick(scope.row)"
                        >处理
                        </el-button>
                        <el-button
                            :disabled="scope.row.status !== 2 || scope.row.source === 2"
                            size="small"
                            type="text"
                            @click="notify(scope.row.id)"
                        >通知提交人
                        </el-button>
                        <el-button
                            size="small"
                            type="text"
                            @click="deleteFunc(scope.row.id)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination-container">
                <el-pagination
                    @size-change="sizeChangeHandler"
                    @current-change="currentChangeHandler"
                    :current-page.sync="pagination.pageNo"
                    :page-sizes="[10, 30, 50]"
                    :page-size="pagination.pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :page-count="pagination.pages"
                    :total="pagination.total"
                >
                </el-pagination>
            </div>
        </div>

        <el-dialog
            title="处理"
            :visible.sync="isBatchDialogShow"
            width="30%"
            :before-close="dialogCancel">
            <div>
                <el-form :model="queryForm" label-width="80px" :rules="formRule" ref="form" class="form">
                    <el-form-item label="处理信息" prop="batchContent">
                        <el-input type="textarea" :maxlength="500" v-model.trim="queryForm.batchContent" :rows="5" placeholder="请输入处理信息描述"></el-input>
                    </el-form-item>
                </el-form>
            </div>
            <div v-if="queryForm.batchContent !== null && queryForm.batchContent !== undefined" class="word-count">
                {{queryForm.batchContent.length}}/500
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogCancel">取 消</el-button>
                <el-button type="primary" @click="batchSubmit(1)">处 理</el-button>
                <el-button type="primary" @click="batchSubmit(2)" v-show="currentSource === 1">处理并通知发送人</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import moment from 'moment';
    import baseMixin from '@/mixins/baseMixin.js';
    import {
        getTrainRecordListByMangerUser,
        batchTrainRecord,
        delTrainRecordById
    } from '@/api/affairs/affairs';
    import {
        getSchoolTimeAllList
    } from '@/api/system';

    export default {
        name: "moduleDetail",

        data() {
            return {

                dateRange: [new Date() , new Date()],
                startDate: moment().format('YYYY-MM-DD'),
                endDate: moment().format('YYYY-MM-DD'),

                isBatchDialogShow: false,
                queryForm: {
                    batchContent: ''
                },
                formRule: {
                    batchContent: [{
                        required: true,
                        message: '处理信息不能为空',
                        trigger: 'blur'
                    }]
                },
                id: this.$route.query.id,
                dataList: [],
                status: 0,
                currentMessageId: null,
                currentSource: 2,
                containerHeight: 0
            }
        },
        created() {
            moment.locale('zh-cn');
            getSchoolTimeAllList()
                .then(res => res.data)
                .then(data => {
                    const pageData = data.data.find(({isCurrent}) => isCurrent == 1);
                    this.startDate = pageData.startDate;
                    this.endDate = pageData.endDate;
                    this.dateRange = [new Date(pageData.startDate), new Date(pageData.endDate)];

                    this.getTrainRecordListByMangerUserFunc();

                })
        },
        computed: {
            exportURL() {
                return global.BasePath + 'structure/throughTrain/exportTrainRecordListByMangerUser?typeId=' + this.id + '&endDate=' + this.endDate + '&startDate=' + this.startDate + '&status=' + this.status + '&token=' + this.$store.getters.token;
            }
        },
        mounted() {
            this.containerHeight = window.innerHeight > 950 ? window.innerHeight - 210 : window.innerHeight - 350;
        },
        mixins: [baseMixin],
        filters: {
            parseSource(value) {
                return ['', '智慧校园', '公众号或网站'][value]
            },
            parseStatus(status) {
                return ['', '未处理', '已处理', '已通知'][status];
            },
            parseStatus2(status) {
                return ['', '未处理', '已处理', '已处理'][status];
            },
        },
        methods: {
            dateRangeChange() {
                this.startDate = moment(this.dateRange[0]).format('YYYY-MM-DD');
                this.endDate = moment(this.dateRange[1]).format('YYYY-MM-DD');

                this.getTrainRecordListByMangerUserFunc();
            },
            changeHandler() {
                this.pagination.pageSize = 10;
                this.pagination.pageNo = 1;
                this.getTrainRecordListByMangerUserFunc();
            },
            batchClick(item) {
                this.currentMessageId = item.id;
                this.currentSource = item.source;
                this.isBatchDialogShow = true;
            },
            dialogCancel() {
                this.isBatchDialogShow = false;
                this.queryForm.batchContent = '';
            },
            deleteFunc(id) {
                this.$confirm('是否删除该留言?', '删除', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    delTrainRecordById({
                        recordId: id
                    })
                        .then(res => res.data)
                        .then(data => {
                            if(data.result) {
                                this.$message({
                                    type: 'success',
                                    message: '删除成功'
                                });
                                this.getTrainRecordListByMangerUserFunc();
                            }
                        })
                });
            },
            batchSubmit(batchType) {
                this.$refs.form.validate((isValid) => {
                    if(isValid) {
                        batchTrainRecord({
                            id: this.currentMessageId,
                            batchType,
                            status: ['', 2, 3, 3][batchType],
                            batchContent: this.queryForm.batchContent
                        })
                            .then(res => res.data)
                            .then(data => {
                                if(data.result) {
                                    this.$message({
                                        type: 'success',
                                        message: '处理成功'
                                    });
                                    this.getTrainRecordListByMangerUserFunc();
                                    this.dialogCancel();
                                }
                            })
                    }
                });
            },
            notify(id) {
                this.$confirm('是否通知提交人?', '通知', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    batchTrainRecord({
                        id,
                        batchType: 3,
                        status: 3,
                        batchContent: this.queryForm.batchContent
                    })
                        .then(res => res.data)
                        .then(data => {
                            if(data.result) {
                                this.$message({
                                    type: 'success',
                                    message: '通知成功'
                                });
                                this.getTrainRecordListByMangerUserFunc();
                                this.dialogCancel();
                            }
                        })
                });

            },
            calcInterval(datetime1, datetime2) {
                if(!datetime1 || !datetime2) {
                    return '--'
                } else {
                    const dateObj1 = moment(datetime1),
                        dateObj2 = moment(datetime2);
                    let resultStr = dateObj2.diff(dateObj1, 'hours');
                    return `${resultStr}小时`;
                }
            },
            currentChangeHandler(pageNo) {
                this.pagination.pageNo = pageNo;
                this.getTrainRecordListByMangerUserFunc();
            },
            sizeChangeHandler(pageSize) {
                this.pagination.pageNo = 1;
                this.pagination.pageSize = pageSize;
                this.getTrainRecordListByMangerUserFunc();
            },
            getTrainRecordListByMangerUserFunc() {
                getTrainRecordListByMangerUser({
                    content: '',
                    pageNo: this.pagination.pageNo,
                    pageSize: this.pagination.pageSize,
                    typeId: this.id,
                    status: this.status,
                    startDate: this.startDate,
                    endDate: this.endDate,
                })
                    .then(res => res.data)
                    .then(data => {
                        this.dataList= data.data.dataList;
                        this.pagination.total = data.data.pagination.total
                    })
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../../../commonsPC/styles/mixins";

    @include reset-global;

    .page {
        padding: 20px;
        min-width: 1240px;
        /*width: 80%;*/
        margin: 0 auto;
        box-sizing: border-box;
    }
    .page-main {
        padding: 20px 0 0 0;
    }
    .content-container {
        @include nowrap;
        width: 100%;
    }
    .word-count {
        text-align: right;
    }
</style>
<style>
    a {
        color: #409EFF !important;
        text-decoration: none !important;
    }
</style>



// WEBPACK FOOTER //
// src/views/affairs/moduleDetail.vue